import { ContentItem } from 'kentico-cloud-delivery';
import get from 'lodash/get';

export default class BlogImageSlider extends ContentItem {
  constructor() {
    super({
      propertyResolver: fieldName => `_${fieldName}`,
      richTextResolver: item => `<object slides=${JSON.stringify(item.imageSlides.map(image => image.imageSlide))}
                                  constructor="${item.type}"/>`,
    });
  }

  get type() {
    return get(this, 'system.type', '');
  }

  get imageSlides() {
    return get(this, '_image_slides', []);
  }
}


// WEBPACK FOOTER //
// ./src/models/BlogImageSlider.model.js